import { isMobile } from '@/utils';
import Tracker from './tracker';

class AffiliateTracker extends Tracker {
  /*
   *
   * @desc: 推广联盟埋点
   * @param {string} action 事件操作
   * @param {object} eventLabel 事件标签
   *
   */
  affiliatePage = ({ action, eventLabel, value = '' }) => {
    let label = eventLabel;
    try {
      switch (action) {
        case 'promo_link_copy':
          label = eventLabel;
          break;
        default:
      }
      this.commonTracker({
        category: `${isMobile() ? 'mobile' : 'pc'}_affiliate`,
        action,
        label,
        value,
      });
    } catch (e) {
      console.log(e);
    }
  };
}

const T = new AffiliateTracker();
export default T;
